// extracted by mini-css-extract-plugin
module.exports = {"AuthPopup":"AuthPopup_AuthPopup__1k3uz","form":"AuthPopup_form__rBAja","fieldset":"AuthPopup_fieldset__3G2cA","or":"AuthPopup_or__1b42q","options":"AuthPopup_options__26QQY"};